<template>
  <TProse :responsive="false">
    {{ text }}
  </TProse>
</template>

<script setup lang="ts">
export interface propsInterface {
  text?: string
}

defineProps<propsInterface>()
</script>
